import GetBasketRequestModel from '../../../generated/types/model/request/GetBasketRequestModel';

export default class GetBasketRequestViewModel extends GetBasketRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
